import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import messaging from './asyncReducers/messaging';
import { MessagingSlice } from './types';

const messagingExtraReducers = (builder: ActionReducerMapBuilder<MessagingSlice>) => {
    messaging(builder);
};

export default messagingExtraReducers;
